import ApiService from "@/core/services/ApiService";

class AllergyService {

    public static create(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/allergy', data)
    }

}

export default AllergyService;